export default __webpack_public_path__ + "static/media/otta.25f0e14d.png";